(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Apply the chosen sorting right away. */
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-sort-select]')) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  /* Business customers: show the company field, preselect it from #aziende links. */
  (() => {
    const sync = (form) => {
      const business = form.querySelector('[data-business-choice]');
      const field = form.querySelector('[data-business-field]');
      if (business && field) field.hidden = !business.checked;
    };

    const preselect = () => {
      const hash = decodeURIComponent(window.location.hash.slice(1));
      if (!hash) return;
      const target = document.getElementById(hash);
      const form = target?.closest('.contact-form__panel')?.querySelector('form');
      const business = form?.querySelector('[data-business-choice]');
      if (!business) return;
      business.checked = true;
      sync(form);
    };

    document.addEventListener('change', (event) => {
      if (event.target.name === 'contact[Tipo cliente]') sync(event.target.form);
    });
    document.querySelectorAll('.contact-form__panel form').forEach(sync);
    window.addEventListener('hashchange', preselect);
    preselect();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /* The welcome window: copy the code, with a fallback where the clipboard is not allowed. */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-welcome-copy]');
    if (!button) return;
    const code = button.getAttribute('data-code') || '';
    let copied = false;

    try {
      await navigator.clipboard.writeText(code);
      copied = true;
    } catch (error) {
      const helper = document.createElement('textarea');
      helper.value = code;
      helper.setAttribute('readonly', '');
      helper.style.position = 'absolute';
      helper.style.left = '-9999px';
      (button.closest('dialog') || document.body).appendChild(helper);
      helper.select();
      try {
        copied = document.execCommand('copy');
      } catch (fallbackError) {
        copied = false;
      }
      helper.remove();
    }

    const status = button.closest('.welcome-modal__inner')?.querySelector('[data-welcome-status]');
    if (copied) {
      const label = button.textContent;
      button.textContent = button.getAttribute('data-copied');
      button.classList.add('is-copied');
      if (status) status.textContent = button.getAttribute('data-copied');
      setTimeout(() => {
        button.textContent = label;
        button.classList.remove('is-copied');
      }, 2500);
    } else if (status) {
      status.textContent = code;
    }
  });

  /* "Cookie preferences" reopens the Shopify cookie banner when it is active; otherwise the link opens the cookie policy. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== 'function') return;
    event.preventDefault();
    window.privacyBanner.showPreferences();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /**
   * Desktop dropdowns open on hover and keyboard focus through CSS;
   * the chevron buttons also toggle them for touch screens.
   */
  class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.toggles = [...this.querySelectorAll('button[aria-controls][aria-expanded]')];
      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', () => this.toggle(toggle));
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll(true);
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      });
    }

    toggle(toggle) {
      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';
      this.closeAll();
      toggle.setAttribute('aria-expanded', String(willOpen));
    }

    closeAll(returnFocus = false) {
      this.toggles.forEach((toggle) => {
        if (toggle.getAttribute('aria-expanded') !== 'true') return;
        toggle.setAttribute('aria-expanded', 'false');
        if (returnFocus) toggle.focus();
      });
    }
  }

  if (!customElements.get('header-menu')) customElements.define('header-menu', HeaderMenu);

  /* The logo shrinks once the page scrolls, as on the current site. */
  (() => {
    const header = document.querySelector('.site-header');
    if (!header) return;
    let ticking = false;
    const update = () => {
      header.classList.toggle('site-header--scrolled', window.scrollY > 8);
      ticking = false;
    };
    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
    update();
  })();

  /* Keep the cart count in sync after products are added or changed without a page reload. */
  document.addEventListener('cart:updated', (event) => {
    const count = event.detail?.cart?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = count;
      badge.hidden = count === 0;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-band"] && !Shopify.designMode) return;
  try {
    
  /*
   * Chrome never starts loading a lazy image that is fixed to the viewport inside
   * a clipped band, so the parallax photo stayed black: load it when the band gets near.
   */
  (() => {
    const bands = [...document.querySelectorAll('.photo-band--parallax')].filter((band) =>
      band.querySelector('.photo-band__image[loading="lazy"]')
    );
    if (bands.length === 0) return;

    const load = (band) => {
      const image = band.querySelector('.photo-band__image[loading="lazy"]');
      if (image) image.loading = 'eager';
    };

    if (!('IntersectionObserver' in window)) {
      bands.forEach(load);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          load(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '100% 0px' }
    );
    bands.forEach((band) => observer.observe(band));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  /* "Mostra altri": reveal the products hidden after the first row. */
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-show-more]');
    if (!trigger) return;
    const grid = document.getElementById(trigger.getAttribute('aria-controls'));
    grid?.querySelectorAll('[data-more-item]').forEach((item) => {
      item.hidden = false;
    });
    const firstRevealed = grid?.querySelector('[data-more-item] a');
    trigger.closest('.product-grid__more')?.remove();
    firstRevealed?.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  /* Loads Shopify's related products for this product and fills the section. */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.querySelector('.product-grid')) return;
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /**
   * <product-gallery>: swipeable slides with thumbnails; follows the selected variant's photo.
   */
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('.product-gallery__slides');
      this.thumbs = [...this.querySelectorAll('.product-gallery__thumb')];
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.show(thumb.dataset.mediaId));
      });

      const initial = this.querySelector('.product-gallery__slide[data-initial]');
      if (initial && initial !== this.slides.firstElementChild) this.show(initial.dataset.mediaId, false);

      document.addEventListener('product:media-change', (event) => {
        if (event.detail.sectionId === this.dataset.sectionId && event.detail.mediaId) {
          this.show(String(event.detail.mediaId));
        }
      });

      if ('IntersectionObserver' in window && this.thumbs.length) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.markCurrent(entry.target.dataset.mediaId);
            });
          },
          { root: this.slides, threshold: 0.6 }
        );
        this.slides.querySelectorAll('.product-gallery__slide').forEach((slide) => observer.observe(slide));
      }
    }

    show(mediaId, animate = true) {
      const slide = this.slides.querySelector(`.product-gallery__slide[data-media-id="${mediaId}"]`);
      if (!slide) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.slides.scrollTo({ left: slide.offsetLeft, behavior: animate && !reduceMotion ? 'smooth' : 'auto' });
      this.markCurrent(mediaId);
    }

    markCurrent(mediaId) {
      this.thumbs.forEach((thumb) => {
        if (thumb.dataset.mediaId === String(mediaId)) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }
  }

  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);

  /**
   * <product-info>: variant buttons, price/availability updates, quantity, add to cart without reloading.
   */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-product-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.form = this.querySelector('form.product-form');
      this.submit = this.querySelector('[data-add-to-cart]');
      this.message = this.querySelector('[data-form-message]');
      this.labels = {
        add: this.dataset.labelAdd,
        soldOut: this.dataset.labelSoldOut,
        unavailable: this.dataset.labelUnavailable,
      };

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-index]')) this.onOptionChange();
      });

      this.querySelectorAll('[data-quantity-step]').forEach((button) => {
        button.addEventListener('click', () => {
          const input = this.querySelector('.quantity__input');
          const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.quantityStep));
          input.value = next;
        });
      });

      this.form?.addEventListener('submit', (event) => this.onSubmit(event));
    }

    selectedOptions() {
      return [...this.querySelectorAll('.variant-picker__option')].map(
        (fieldset) => fieldset.querySelector('input:checked')?.value
      );
    }

    onOptionChange() {
      const options = this.selectedOptions();
      this.querySelectorAll('.variant-picker__option').forEach((fieldset, index) => {
        const label = fieldset.querySelector('[data-selected-value]');
        if (label) label.textContent = options[index] ?? '';
      });

      const variant = this.variants.find((candidate) =>
        candidate.options.every((value, index) => value === options[index])
      );

      this.querySelectorAll('[data-variant-notice]').forEach((notice) => {
        const value = notice.dataset.variantNotice;
        notice.hidden = value !== '' && !options.includes(value);
      });

      if (!variant) {
        this.setButton(false, this.labels.unavailable);
        return;
      }

      const idInput = this.querySelector('[data-variant-id]');
      if (idInput) idInput.value = variant.id;

      const price = this.querySelector('[data-price]');
      if (price) price.textContent = variant.price;
      const compare = this.querySelector('[data-compare-price]');
      if (compare) {
        compare.textContent = variant.compare || '';
        compare.hidden = !variant.compare;
      }

      this.setButton(variant.available, variant.available ? this.labels.add : this.labels.soldOut);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.media) {
        document.dispatchEvent(
          new CustomEvent('product:media-change', {
            detail: { sectionId: this.dataset.sectionId, mediaId: variant.media },
          })
        );
      }
    }

    setButton(enabled, label) {
      if (!this.submit) return;
      this.submit.disabled = !enabled;
      this.submit.textContent = label;
    }

    async onSubmit(event) {
      event.preventDefault();
      if (!this.submit || this.submit.disabled) return;
      this.submit.setAttribute('aria-busy', 'true');
      this.submit.disabled = true;
      this.showMessage('');

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        const result = await response.json();
        if (!response.ok) {
          this.showMessage(result.description || result.message || this.dataset.labelError, true);
          return;
        }
        const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
        const hasDrawer = Boolean(document.querySelector('cart-drawer'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, item: result, openDrawer: hasDrawer } }));
        if (!hasDrawer) this.showMessage(this.dataset.labelAdded);
      } catch (error) {
        this.showMessage(this.dataset.labelError, true);
      } finally {
        this.submit.removeAttribute('aria-busy');
        this.submit.disabled = false;
      }
    }

    showMessage(text, isError = false) {
      if (!this.message) return;
      this.message.hidden = !text;
      this.message.classList.toggle('is-error', isError);
      this.message.innerHTML = '';
      if (!text) return;
      this.message.append(text);
      if (!isError && this.dataset.cartUrl) {
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = this.dataset.labelViewCart;
        this.message.append(' ', link);
      }
    }
  }

  if (!customElements.get('product-info')) customElements.define('product-info', ProductInfo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-configurator"] && !Shopify.designMode) return;
  try {
    
  class QuoteConfigurator extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-qc-data]');
      if (!data) return;
      this.data = JSON.parse(data.textContent);
      this.data.discounts.sort((a, b) => a.min - b.min);
      this.money = new Intl.NumberFormat(this.data.locale, { style: 'currency', currency: this.data.currency });
      this.percent = new Intl.NumberFormat(this.data.locale, { style: 'percent', maximumFractionDigits: 1 });
      this.form = this.querySelector('form');
      this.quantity = this.querySelector('[data-qc-quantity]');
      this.current = 0;
      this.reached = 0;

      this.form.addEventListener('input', () => this.update());
      // Also lifts the quantity to the minimum when an option that needs one (the 100 ml) is chosen.
      this.form.addEventListener('change', () => {
        this.quantity.value = this.count();
        this.update();
      });
      // Enter in a field moves on instead of sending a half-built request.
      this.form.addEventListener('submit', (event) => {
        if (this.current < this.steps().length - 1) {
          event.preventDefault();
          this.go(this.current + 1);
        }
      });
      this.querySelector('[data-qc-next]').addEventListener('click', () => this.go(this.current + 1));
      this.querySelector('[data-qc-back]').addEventListener('click', () => this.go(this.current - 1));
      this.querySelector('[data-qc-progress]').addEventListener('click', (event) => {
        const button = event.target.closest('[data-goto]');
        if (button) this.go(Number(button.dataset.goto));
      });
      this.querySelectorAll('[data-qc-quantity-step]').forEach((button) =>
        button.addEventListener('click', () => {
          this.quantity.value = Math.max(this.minimum(), this.count() + Number(button.dataset.qcQuantityStep));
          this.update();
        })
      );

      // Product pages link here with ?collezione=<product title>: that collection starts chosen.
      const wanted = new URLSearchParams(window.location.search).get('collezione');
      const preset = [...this.querySelectorAll('[data-qc-product]')].find((input) => input.value === wanted);
      if (preset) preset.checked = true;

      this.querySelectorAll('[data-qc-progress], [data-qc-nav], [data-qc-preview]').forEach(
        (element) => (element.hidden = false)
      );
      this.update();
    }

    count() {
      return Math.max(this.minimum(), parseInt(this.quantity.value, 10) || 1);
    }

    /* Option values of the chosen product, in variant order. */
    chosen() {
      return [...this.querySelectorAll(`[data-product="${this.product()}"] input:checked`)].map((input) => input.value);
    }

    /* An option sold only on reservation (the 100 ml) comes with a minimum quantity. */
    minimum() {
      const { value, quantity } = this.data.minimum;
      return value && this.chosen().includes(value) ? quantity : 1;
    }

    product() {
      const input = this.querySelector('[data-qc-product]:checked');
      return input ? input.dataset.qcProduct : '';
    }

    /* The option steps of the products not chosen drop out of the flow. */
    steps() {
      const product = this.product();
      return [...this.querySelectorAll('[data-step]')].filter(
        (step) => step.dataset.product === undefined || step.dataset.product === product
      );
    }

    isComplete(step) {
      return !step.hasAttribute('data-qc-required') || !!step.querySelector('input:checked');
    }

    go(index) {
      const steps = this.steps();
      let target = Math.max(0, Math.min(index, steps.length - 1));
      const missing = steps.findIndex((step, position) => position < target && !this.isComplete(step));
      if (missing !== -1) target = missing;
      this.current = target;
      this.reached = Math.max(this.reached, target);
      this.update();
      steps[target].querySelector('.qc-step__title')?.focus({ preventScroll: true });
      if (this.form.getBoundingClientRect().top < 0) {
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.form.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      }
    }

    price() {
      const product = this.data.products[Number(this.product())];
      if (!product) return null;
      const chosen = this.chosen().join('\n');
      const variant =
        product.variants.length === 1
          ? product.variants[0]
          : product.variants.find((item) => item.options.join('\n') === chosen);
      if (!variant) return null;

      const extras = [...this.querySelectorAll('[data-surcharge]:checked')]
        .filter((input) => !input.matches(':disabled'))
        .reduce((sum, input) => sum + Number(input.dataset.surcharge), 0);
      const unit = variant.price + extras;
      const subtotal = unit * this.count();
      const tier = this.data.discounts.filter((item) => this.count() >= item.min).pop();
      const percent = tier ? tier.percent : 0;
      const discount = Math.round((subtotal * percent) / 100);
      return { unit, subtotal, percent, discount, total: subtotal - discount };
    }

    fill(list, rows) {
      list.replaceChildren(
        ...rows.flatMap(([term, detail]) => {
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = term;
          dd.textContent = detail;
          return [dt, dd];
        })
      );
    }

    update() {
      const product = this.product();
      this.querySelectorAll('[data-step][data-product]').forEach((step) => (step.disabled = step.dataset.product !== product));
      const minimum = this.minimum();
      this.quantity.min = minimum;
      const minimumNote = this.querySelector('[data-qc-minimum]');
      if (minimumNote) minimumNote.hidden = minimum === 1;
      const ribbon = this.querySelector('[data-qc-ribbon]');
      if (ribbon) {
        ribbon.hidden = ribbon.disabled = !this.querySelector('[data-qc-packaging][data-ribbon]:checked');
      }

      const steps = this.steps();
      this.current = Math.min(this.current, steps.length - 1);
      this.reached = Math.min(this.reached, steps.length - 1);
      this.querySelectorAll('[data-step]').forEach((step) => (step.hidden = step !== steps[this.current]));

      const progress = this.querySelector('[data-qc-progress]');
      progress.replaceChildren(
        ...steps.map((step, index) => {
          const item = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.goto = index;
          button.textContent = step.dataset.stepLabel;
          button.disabled = index > this.reached;
          if (index === this.current) item.setAttribute('aria-current', 'step');
          item.append(button);
          return item;
        })
      );
      const active = progress.querySelector('[aria-current]');
      if (active) progress.scrollLeft = active.offsetLeft - progress.offsetLeft - 16;

      const step = steps[this.current];
      const next = this.querySelector('[data-qc-next]');
      next.hidden = this.current === steps.length - 1;
      next.disabled = !this.isComplete(step);
      this.querySelector('[data-qc-back]').disabled = this.current === 0;

      const choices = product
        ? [...this.form.querySelectorAll('[data-qc-summary-field]')]
            .filter((field) => !field.matches(':disabled') && (field.type !== 'radio' || field.checked) && field.value.trim())
            .map((field) => [field.name.slice(8, -1), field.value.trim()])
        : [];
      this.querySelectorAll('[data-qc-summary]').forEach((list) => this.fill(list, choices));

      const price = this.price();
      const labels = this.data.labels;
      const format = (cents) => this.money.format(cents / 100);
      const rows = price
        ? [
            [labels.unit, format(price.unit)],
            [labels.subtotal, format(price.subtotal)],
            ...(price.discount ? [[`${labels.discount} (${this.percent.format(price.percent / 100)})`, `−${format(price.discount)}`]] : []),
            [labels.total, format(price.total)],
          ]
        : [];
      this.querySelectorAll('[data-qc-breakdown]').forEach((list) => this.fill(list, rows));
      this.querySelector('[data-qc-total]').textContent = price ? format(price.total) : '–';
      this.querySelector('[data-qc-field="unit"]').value = price ? format(price.unit) : '';
      this.querySelector('[data-qc-field="discount"]').value =
        price && price.discount ? `${this.percent.format(price.percent / 100)} (−${format(price.discount)})` : '';
      this.querySelector('[data-qc-field="total"]').value = price ? format(price.total) : '';

      // The colour photo when there is one, otherwise the collection photo.
      const source = [...this.querySelectorAll('[data-image]:checked')].filter((input) => !input.matches(':disabled')).pop();
      const media = this.querySelector('[data-qc-preview-media]');
      let image = media.querySelector('img');
      if (source && !image) {
        image = Object.assign(document.createElement('img'), { alt: '', width: 900, height: 1125 });
        media.prepend(image);
      }
      if (image) {
        if (source && image.getAttribute('src') !== source.dataset.image) image.src = source.dataset.image;
        image.hidden = !source;
      }
      this.querySelector('[data-qc-preview-empty]').hidden = !!source;
    }
  }

  if (!customElements.get('quote-configurator')) customElements.define('quote-configurator', QuoteConfigurator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quote-form"] && !Shopify.designMode) return;
  try {
    
  /* Preselect the collection passed by the product page (?collezione=…). */
  (() => {
    const wanted = new URLSearchParams(window.location.search).get('collezione');
    if (!wanted) return;
    const needle = wanted.trim().toLowerCase();
    document.querySelectorAll('[data-quote-collection]').forEach((select) => {
      const options = [...select.options];
      const match =
        options.find((option) => option.value.toLowerCase() === needle) ||
        options.find((option) => option.value.toLowerCase().includes(needle) || needle.includes(option.value.toLowerCase()));
      if (match) select.value = match.value;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
